import Card from "react-bootstrap/Card";
import { useIntl } from "react-intl";

import UserNotifications from "./UserNotifications.jsx";

const messages = {
  notifications: {
    id: "modules.UserNotification.components.Dashboard.notifications",
    description: "List of notifications",
    defaultMessage: "Notifications",
  },
};

const Dashboard = () => {
  const { formatMessage } = useIntl();

  return (
    <Card>
      <Card.Header className="card-header-borderless" as="h3">
        {formatMessage(messages.notifications)}
      </Card.Header>
      <Card.Body>
        <UserNotifications />
      </Card.Body>
    </Card>
  );
};
export default Dashboard;
